import React from 'react';
import { FC } from 'react';
import { useParams } from 'react-router-dom';
import { GuideCmsContextProvider } from './GuideCmsContext';
import { CommentsContextProvider } from './sidebar/comments/CommentsContext';
import { Layout } from './Layout';
import { ThreadsContextProvider } from './sidebar/tiptapComments/context';
import { ReferencesContextProvider } from './sidebar/references/ReferencesContext';
import { GET_GUIDE_MIGRATION } from '../../guideArchive/guideArchive.graphql';
import { useQuery } from '@apollo/client';
import { TiptapDocumentItemFragment } from '../../__generated__/graphql';

export const GuideCmsReadOnlyPage: FC = () => {
  const { id } = useParams();

  if (!id) return null;
  return (
    <GuideCmsContextProvider guideId={id}>
      <CommentsContextProvider>
        <Layout isEditing={false} />
      </CommentsContextProvider>
    </GuideCmsContextProvider>
  );
};

export const GuideCmsEditPage: FC = () => {
  const { id } = useParams();

  if (!id) return null;
  return (
    <GuideCmsContextProvider guideId={id}>
      <ReferencesContextProvider>
        <ThreadsContextProvider>
          <CommentsContextProvider>
            <Layout isEditing={true} />
          </CommentsContextProvider>
        </ThreadsContextProvider>
      </ReferencesContextProvider>
    </GuideCmsContextProvider>
  );
};

export const ArchivedGuideCmsEditPage: FC = () => {
  const { id } = useParams();
  const { data } = useQuery(GET_GUIDE_MIGRATION, { variables: { id } });
  const migration = data?.guideMigration;

  if (!migration || !migration.version || !migration.tiptapDocument) return null;

  return (
    <GuideCmsContextProvider guideId={migration.guideId} archivedTiptapDocument={migration.tiptapDocument} archivedVersion={migration.version}>
      <ReferencesContextProvider>
        <ThreadsContextProvider>
          <CommentsContextProvider>
            <Layout isEditing={true} />
          </CommentsContextProvider>
        </ThreadsContextProvider>
      </ReferencesContextProvider>
    </GuideCmsContextProvider>
  );
};
